import request from "../request";
import Url from "../url/main";

const setMainInfo = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setMainInfo + path, data, options);
};
const setQuestionnaireData = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setQuestionnaireData + path, data, options);
};
const sendEmail = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.sendEmail + path, data, options);
};

const getMainInfoList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getMainInfoList + path, data, options);
};
const getMainInfoAndQuestionDataDetails = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(
    Url.getMainInfoAndQuestionDataDetails + path,
    data,
    options
  );
};

export default {
  setMainInfo,
  setQuestionnaireData,
  sendEmail,

  getMainInfoList,
  getMainInfoAndQuestionDataDetails,
};
